import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

/**
 * Diz sobre quantos meses a leitura da tela se sustenta.
 *
 * Existe porque uma média de quatro meses exibida numa janela de seis parece
 * uma média de seis. Enquanto a janela de exibição era fixa em três meses
 * contíguos isso não aparecia; com N períodos, um mês não informado no meio da
 * série muda o significado de todo número agregado da tela.
 *
 * `contiguoMax` fica no tooltip e não no rótulo porque só importa para quem vai
 * olhar tendência: média móvel e sazonalidade exigem meses vizinhos, e a
 * contagem total não serve para elas.
 */
const plural = (n, singular, plural_) => `${n} ${n === 1 ? singular : plural_}`;

const CoberturaChip = ({ cobertura, size = 'small' }) => {
  if (!cobertura || !cobertura.janela) return null;

  const { total, janela, contiguoMax, lacunas } = cobertura;
  const completa = total >= janela;

  const rotulo = completa
    ? `${plural(total, 'mês informado', 'meses informados')}`
    : `${total} de ${plural(janela, 'mês informado', 'meses informados')}`;

  const detalhe = [];
  if (!completa) {
    const faltando = (lacunas || []).length;
    detalhe.push(
      faltando
        ? `Sem lançamento em: ${(lacunas || []).join(', ')}.`
        : `${janela - total} ${janela - total === 1 ? 'mês' : 'meses'} da janela sem lançamento.`
    );
    detalhe.push('Toda média desta tela conta só os meses informados.');
  }
  if (contiguoMax && contiguoMax < total) {
    detalhe.push(`Maior sequência sem buraco: ${plural(contiguoMax, 'mês', 'meses')}.`);
  }
  if (!detalhe.length) detalhe.push('Série contínua, sem mês faltando na janela.');

  return (
    <Tooltip title={detalhe.join(' ')}>
      <Chip
        icon={completa ? <EventAvailableIcon /> : <ReportProblemOutlinedIcon />}
        label={rotulo}
        size={size}
        variant="outlined"
        color={completa ? 'default' : 'warning'}
      />
    </Tooltip>
  );
};

export default CoberturaChip;
